var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89 3.312v10.909L3.05 16.88a.669.669 0 0 1-1.044-.446L2 16.343V7.038c0-.183.078-.357.212-.48l.071-.057L6.89 3.312Zm11.104.254.006.091v9.305a.652.652 0 0 1-.212.48l-.071.057-4.606 3.187V5.776l3.84-2.655a.669.669 0 0 1 1.043.445Zm-9.772-.253 3.555 2.461v10.91L8.222 14.22V3.313Z",
    fill: "#666"
  })));
};
export default SvgMap;